<template>
<div class="chapter">
<div class="inner_page">
<div> <a id="cr"></a></div>
<p class="copyright1">First published in 2002 by Mercat Press Ltd<br/>
  Reprinted 2002, 2003 (three times), 2004, 2005, 2006<br/>
  New edition published 2008 by Birlinn Limited</p>
<p class="copyright2">Birlinn Limited<br/>
  West Newington House<br/>
  10 Newington Road<br/>
  Edinburgh<br/>
  EH9 1QS<br/>
<i><a href="http://www.birlinn.co.uk" target="_blank">www.birlinn.co.uk</a></i></p>
<p class="copyright2">Copyright © Jess Smith 2002, 2008</p>
<p class="copyright2">The story ‘A Natural Love’ was first published in <i>The Scots Magazine</i>, September 2000.</p>
<p class="copyright2">The moral right of Jess Smith to be identified as the author of this work has been asserted by her in accordance with the Copyright, Designs and Patents Act 1988</p>
<p class="copyright2">All rights reserved. No part of this publication may be reproduced, stored or transmitted in any form without the express written permission of the publisher.</p>
<p class="copyright2">ISBN-13: 978 1 84158 702 8<br/>
  eBook ISBN: 978 0 85790 178 1</p>
<p class="copyright2">Version 1.0</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004_cr.vue?365d07ec